import React from 'react';
import PropTypes from 'prop-types';

import LoadingWrapper from '@decisiv/ui-components/lib/components/Loading';
import { CenteredContainer } from './style';

export default function Loading({
  loading,
  children = null,
  description = '',
  title = 'Loading ...',
}) {
  return loading ? (
    <CenteredContainer flexDirection="column" padding={1}>
      <LoadingWrapper size="large" title={title} description={description} />
    </CenteredContainer>
  ) : (
    children
  );
}
Loading.propTypes = {
  loading: PropTypes.bool.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  title: PropTypes.string,
};
